import { IS_REQUIRED_ERROR } from '../../../utils/formValidation/commonErrorConstants';
import { checkDiff } from '../../../utils/formValidation/errorCheckingFunctions';
import {
    getMultiSelectMessage,
    getNumMinMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    if (!newEntry.daysWithoutInitialAppointmentUntilRecordClosure) {
        newErrors = {
            ...newErrors,
            daysWithoutInitialAppointmentUntilRecordClosure: {
                error: true,
                message: IS_REQUIRED_ERROR
            }
        };
    }
    if (newEntry.deleteParticipantPiOnContractClosure) {
        if (!newEntry.deleteParticipantPiOnContractClosureDays) {
            newErrors = {
                ...newErrors,
                deleteParticipantPiOnContractClosureDays: {
                    error: true,
                    message: IS_REQUIRED_ERROR
                }
            };
        }
    }

    if (newEntry.deleteParticipantPiOnParticipantClosure) {
        if (!newEntry.deleteParticipantPiOnParticipantClosureDays) {
            newErrors = {
                ...newErrors,
                deleteParticipantPiOnParticipantClosureDays: {
                    error: true,
                    message: IS_REQUIRED_ERROR
                }
            };
        }
    }

    if (newEntry.configureOnHoldStatus) {
        if (!newEntry.daysInOnHoldStatus) {
            newErrors = {
                ...newErrors,
                daysInOnHoldStatus: {
                    error: true,
                    message: IS_REQUIRED_ERROR
                }
            };
        } else if (newEntry.daysInOnHoldStatus < 1) {
            newErrors = {
                ...newErrors,
                daysInOnHoldStatus: {
                    error: true,
                    message: getNumMinMessage()
                }
            };
        }
    }

    if (newEntry.participantStatuses.length < 1) {
        newErrors = {
            ...newErrors,
            participantStatuses: {
                error: true,
                message: getMultiSelectMessage('Status')
            }
        };
    } else {
        newEntry.participantStatuses.forEach((el) => {
            if (el.toParticipantStatuses.length < 1) {
                newErrors = {
                    ...newErrors,
                    [`toParticipantStatuses-${el.participantStatusId}`]: {
                        error: true,
                        message: getMultiSelectMessage('To Status')
                    },
                    [`accordion-${el.participantStatusId}`]: { error: true }
                };
            }
        });
    }

    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);

    return newErrors;
};
